import Block from "./Block";
import classes from "./Board.module.css";

const Board = props => {
    const checkWinning = (winningCombination, col, row) => {
        if (!winningCombination) { return false }
        for (let combination of winningCombination) {
            if (combination[0] === col && combination[1] === row) { return true; }
        }
        return false;
    };

    const colClasses = `${classes["board-col"]} ${props.isXNext && !props.gameover ? classes["board-col-active"] : ""}`

    const rows = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(col => {
        return <div key={col} className={colClasses} onClick={() => props.onMove(col)}>
            {[0, 1, 2, 3, 4, 5].map(row => {
                return <Block
                    gameover={props.gameover}
                    winning={checkWinning(props.winner.winningCombination, col, row)}
                    key={row}
                    value={props.board[col][row]}
                />
            })}
        </div>
    });

    return <div className={classes["board"]}>
        {rows}
    </div>
}

export default Board;